import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";
import { Container, Row, Col, Button, Spinner } from "reactstrap";
import { ToastContainer } from "react-toastify";
import ScannerList from "./ScannerList";
import GenerateLinksForm from "./GenerateLinksForm";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import { withRouter } from "../../components/Common/withRouter";

// Utilities
import {
    createNotificationHelpers,
    handleCouponScannerInputChange,
    loadCouponScannerDataHandler,
    updateCouponScannerHandler,
    generateLinksHandler,
    getStoreFromLocation
} from "../utils";

class CouponScanner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            TotalCustomers: 0,
            couponScanner: [],
            loading: true,
            store: '',
            newStore: '',
            siteUrl: {},
            couponsData: {},
            websiteUrls: {},
            domain: '',
            handle: '',
            query: '',
            id: '',
            scannerWebsite: [],
            merchantInfo: {}
        };

        // Initialize notification helpers
        const notifications = createNotificationHelpers();
        this.notify_info = notifications.notify_info;
        this.notify_error = notifications.notify_error;
        this.notify_success = notifications.notify_success;
    }

    handleInputChange = (e) => {
        handleCouponScannerInputChange(e, (updater) => this.setState(updater));
    };

    /**
     * Updates a coupon scanner entry
     */
    handleUpdateCouponScanner = async (id) => {
        const success = await updateCouponScannerHandler(
            id,
            this.state,
            this.notify_error,
            this.notify_success
        );

        if (success) {
            await this.loadCouponScanner();
        }
    };


    /**
     * Loads coupon scanner data for a store
     */
    loadCouponScanner = async () => {
        const { store } = this.state;
        if (!store) return;

        this.setState({ loading: true });

        const result = await loadCouponScannerDataHandler(
            store,
            this.notify_error,
            this.notify_success,
            this.notify_info
        );

        if (result) {
            this.setState(result);
        }
    }

    async componentDidMount() {
        const location = this.props.location || {};
        const store = getStoreFromLocation(location);

        if (store) {
            this.setState({ store }, () => {
                this.loadCouponScanner();
            });
        } else {
            // redirect to stores page if store is not provided
            this.props.navigate('/stores');
        }
    }


    handleSearchInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    /**
     * Generates coupon scanner links
     */
    handleGenerateLinks = async (e) => {
        e.preventDefault();
        const { domain, handle, query } = this.state;

        this.setState({ loading: true });

        const success = await generateLinksHandler(
            { domain, handle, query },
            this.state,
            this.notify_error,
            this.notify_success
        );

        if (success) {
            await this.loadCouponScanner();
        } else {
            this.setState({ loading: false });
        }
    }

    render() {
        const { couponScanner, websiteUrls, siteUrl, store, couponsData, merchantInfo, loading } = this.state;

        return (
            <React.Fragment>
                <div className="page-content">
                    <Helmet>
                        <title>Veeper | AP - Coupon Scanner</title>
                    </Helmet>
                    <Container fluid>
                        <Breadcrumbs
                            title={this.props.t(`Coupon Scanner`)}
                            breadcrumbItem={this.props.t(`Coupon Scanner`)}
                        />
                        <ToastContainer />

                        <Row>
                            <Col>
                                <h5 style={{ fontWeight: 'lighter', fontSize: '15px', color: '#020' }}>Coupon Scanner for {store}</h5>
                            </Col>
                            <Col className="d-flex justify-content-end gap-2">
                                <Link to={{ pathname: "/merchant-details", search: store ? `?store=${encodeURIComponent(store)}` : undefined, state: { data: merchantInfo, storeStatus: 'active' } }}>
                                    <Button className="btn btn-dark">
                                        <i className="fa fa-eye"></i> Store Details
                                    </Button>
                                </Link>
                                <Link to={{ pathname: "/stores" }}>
                                    <Button className="btn btn-dark">
                                        <i className="fa fa-arrow-left"></i> Back to Stores
                                    </Button>
                                </Link>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={12}>
                                <h5 style={{ fontWeight: 'lighter', fontSize: '18px', color: '#020', marginBottom: '10px', textAlign: 'center' }}>
                                    Generate Coupon Scanner Links
                                </h5>
                            </Col>
                            <Col xl={12}>
                                <GenerateLinksForm
                                    domain={this.state.domain}
                                    handle={this.state.handle}
                                    query={this.state.query}
                                    loading={loading}
                                    onSubmit={this.handleGenerateLinks}
                                    onInputChange={this.handleSearchInputChange}
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col xl={12}>
                                <h5 style={{ fontWeight: 'lighter', fontSize: '15px', color: '#020', marginBottom: '10px' }}>
                                    List of Coupon Scanner
                                    {loading && (
                                        <Spinner color="primary" className="ms-3" size="sm" />
                                    )}
                                </h5>
                                {!loading && couponScanner.length === 0 && (
                                    <Row>
                                        <Col className="d-flex justify-content-center py-4">
                                            <p>No coupon scanner found</p>
                                        </Col>
                                    </Row>
                                )}
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={12}>
                                <ScannerList
                                    couponScanner={couponScanner}
                                    onUpdate={this.handleUpdateCouponScanner}
                                    websiteUrls={websiteUrls}
                                    siteUrl={siteUrl}
                                    couponsData={couponsData}
                                    handleInputChange={this.handleInputChange}
                                />
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

CouponScanner.propTypes = {
    t: PropTypes.any,
    location: PropTypes.object,
    navigate: PropTypes.func
};

export default withRouter(withTranslation()(CouponScanner));